import script from "./user-profile-othersetting.vue?vue&type=script&setup=true&lang=js"
export * from "./user-profile-othersetting.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__